// extracted by mini-css-extract-plugin
export default {"resource":"Resource_resource__2S0++","green":"Resource_green__KlZOO"};